import useActiveState from "../general/useActiveState";

export default () => {
  const app = useActiveState('app')[0];

  return <div className="account-agreement">
    <iframe src={app.agreementList?.login?.url}/>
  </div>
};